import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    maxWidth: 1200
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2)
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
    maxWidth: 720
  },
  statStrip: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)'
    }
  },
  statCard: {
    padding: theme.spacing(2),
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    cursor: 'pointer',
    transition: 'box-shadow 0.15s ease, transform 0.15s ease',
    '&:hover': {
      boxShadow: theme.shadows[2],
      transform: 'translateY(-1px)'
    }
  },
  statN: {
    fontSize: 22,
    fontWeight: 700
  },
  statL: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    letterSpacing: 0.3
  },
  anomalyNote: {
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(3),
    backgroundColor: theme.palette.warning?.light || '#fdece5'
  },
  tableWrap: {
    marginBottom: theme.spacing(3)
  },
  sectionTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1)
  },
  centrePicker: {
    marginBottom: theme.spacing(2)
  },
  sampleNote: {
    fontSize: 12.5,
    color: theme.palette.text.secondary,
    padding: theme.spacing(1.5, 2)
  },
  footerNote: {
    fontSize: 12.5,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1)
  },
  chipOnTime: {
    backgroundColor: '#e3f2e1',
    color: '#2e6b2b',
    fontWeight: 600
  },
  chipLate: {
    backgroundColor: '#fdf1de',
    color: '#a6650a',
    fontWeight: 600
  },
  chipMissing: {
    backgroundColor: '#fbe3e1',
    color: '#a6392a',
    fontWeight: 600
  },
  chipAbsent: {
    backgroundColor: '#eeeeee',
    color: '#616161',
    fontWeight: 600
  },
  clickableChip: {
    cursor: 'pointer',
    display: 'inline-block'
  },
  clickable: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontWeight: 600,
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textUnderlineOffset: '2px',
    '&:hover': {
      textDecorationStyle: 'solid'
    }
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: theme.spacing(2, 3)
  },
  filterRow: {
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  filterChip: {
    fontWeight: 600
  },
  infoLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4
  },
  infoIcon: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    cursor: 'help'
  },
  deadlineHint: {
    color: theme.palette.text.secondary,
    fontSize: 11.5
  },
  messageText: {
    maxWidth: 220,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'help'
  },
  datePicker: {
    // Size to the date's intrinsic content (no minWidth) so it stays compact.
    width: 'auto',
    padding: theme.spacing(0.5, 1),
    fontSize: 13,
    fontFamily: 'inherit',
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper
  },
  teacherPickerRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    flexWrap: 'wrap'
  },
  teacherAutocomplete: {
    minWidth: 280,
    backgroundColor: theme.palette.background.paper
  },
  loadingWrap: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(6, 0),
    justifyContent: 'center'
  },
  trendBlock: {
    marginBottom: theme.spacing(3)
  },
  trendBlockTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(0.5)
  },
  trendCard: {
    padding: theme.spacing(2, 2, 1),
    marginBottom: theme.spacing(1)
  },
  trendChartWrap: {
    position: 'relative'
  },
  trendSvg: {
    width: '100%',
    height: 220,
    display: 'block'
  },
  trendBarHovered: {
    opacity: 0.75
  },
  trendHoverLine: {
    stroke: theme.palette.text.secondary,
    strokeWidth: 1,
    strokeDasharray: '3 3',
    pointerEvents: 'none'
  },
  trendTooltip: {
    position: 'absolute',
    transform: 'translate(-50%, -100%)',
    marginTop: -10,
    padding: theme.spacing(1, 1.5),
    backgroundColor: '#2b2b2b',
    color: '#fff',
    fontSize: 12,
    lineHeight: 1.5,
    borderRadius: 4,
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
    zIndex: 2,
    boxShadow: theme.shadows[3]
  },
  trendGridLine: {
    stroke: theme.palette.divider,
    strokeWidth: 1
  },
  trendAxisLabel: {
    fontSize: 10,
    fill: theme.palette.text.secondary
  },
  trendBarGood: {
    fill: '#4f9950'
  },
  trendBarWarn: {
    fill: '#d99a2b'
  },
  trendBarBad: {
    fill: '#c8503f'
  },
  trendUp: {
    color: '#2e6b2b',
    fontWeight: 700
  },
  trendDown: {
    color: '#a6392a',
    fontWeight: 700
  },
  trendFlat: {
    color: theme.palette.text.secondary,
    fontWeight: 700
  }
}))

export default useStyles
